<template>
	<div>
		<div class="fw7 fs4 c6 lh125 mb6">{{ productName }}</div>

		<!-- Container for Named -->
		<div style="overflow: scroll" class="pb6 mb3">
			<!-- Header -->
			<p class="fs4 mb4 fw7">{{ t("named") }}</p>
			<div class="flex xs-12 mb3 xs-middle">
				<p class="fs3 fw5 mr2 xs-3" v-for="(item, i) in headerOfNamed" :key="i">
					{{ t(item) }}
				</p>
			</div>
			<!-- Rows -->
			<div v-for="(obj, index) in values" :key="index">
				<!-- Named -->
				<div class="flex xs-12 xs-middle mb1" v-if="values[index]['isNamed']">
					<component
						class="mr2 xs-3"
						v-for="(item, key) in obj"
						:key="key"
						size="small"
						:is="decideComponent(key)"
						v-bind="decideProps(key)"
						@input="handleInput({ index, key, $event })"
						:value="values[index][key]"
					></component>

					<j-button
						class="flex-shrink-0"
						type="error"
						size="xsmall"
						@click="removeRowFromValues(index)"
					>
						<crm-icon name="delete" color="c5" />
					</j-button>
				</div>
			</div>
		</div>

		<!-- Container for Unnamed -->
		<div style="overflow: scroll" class="pb6">
			<!-- Header -->
			<p class="fs4 mb4 fw7">{{ t("unnamed") }}</p>
			<div class="flex xs-12 mb3 xs-middle">
				<p
					class="fs3 fw5 mr2 xs-3"
					v-for="(item, i) in headerOfUnnamed"
					:key="i"
				>
					{{ t(item) }}
				</p>
			</div>
			<!-- Rows -->
			<div v-for="(obj, index) in values" :key="index">
				<!-- Named -->
				<div class="flex xs-12 xs-middle mb1" v-if="!values[index]['isNamed']">
					<component
						class="mr2 xs-3"
						v-for="(item, key) in obj"
						:key="key"
						size="small"
						:is="decideComponent(key)"
						v-bind="decideProps(key)"
						@input="handleInput({ index, key, $event })"
						:value="values[index][key]"
					/>
					<j-button
						class="flex-shrink-0"
						type="error"
						size="xsmall"
						@click="removeRowFromValues(index)"
					>
						<crm-icon name="delete" color="c5" />
					</j-button>
				</div>
			</div>
		</div>

		<!-- Add rows -->
		<j-button
			type="secondary"
			class="mr2 mb6 mt3"
			size="small"
			@click="addNamedRow"
			>{{ t("add_named") }}</j-button
		>
		<j-button
			type="secondary"
			class="mr2 mb6 mt3"
			size="small"
			@click="addUnnamedRow"
			>{{ t("add_unnamed") }}</j-button
		>

		<!-- Applied Taxes -->
		<div
			class="mb3 flex xs-around xs-middle"
			v-for="(item, i) in computedTaxes"
			:key="item.name"
		>
			<div class="xs-6">
				<span class="fs3 fw4">{{ item.name }}:</span>
			</div>
			<div class="xs-6 flex xs-right">
				<span class="fs3 fw4">{{ item.value }}</span>
			</div>
		</div>

		<!-- Pricing -->
		<div
			class="mb3 flex xs-around xs-middle"
			v-for="(item, i) in computedFormattedPricing"
			:key="item.name"
		>
			<div class="xs-6">
				<span class="fs3 fw7">{{ t(item.name) }}:</span>
			</div>
			<div class="xs-6 flex xs-right">
				<span class="fs3 fw7">{{ item.value }}</span>
			</div>
		</div>

		<!-- Save value -->
		<j-button class="mt6" size="small" @click="saveValues">{{
			t("save_values")
		}}</j-button>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect/"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseInputNumber from "@/components/JBaseInputNumber/"
import JBaseToggle from "@/components/JBaseToggle/"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import debounce from "lodash.debounce"
import OccupationInput from "./OccupationInput"

const occupations = [
	{ name: "Admin", value: "Admin" },
	{ name: "Managerial", value: "Managerial" },
	{ name: "Clerical", value: "Clerical" },
	{ name: "Sales", value: "Sales" },
	{ name: "Others", value: "Others" },
	{ name: "Salesman (Carry Jewellery)", value: "Salesman (Carry Jewellery)" },
	{
		name: "Worker/ Goldsmith /Stonepicker",
		value: "Worker/ Goldsmith /Stonepicker"
	},
	{ name: "Private Car Driver", value: "Private Car Driver" },
	{ name: "Amah/ Cleaning Worker", value: "Amah/ Cleaning Worker" },
	{ name: "Messenger/ Office Assistant", value: "Messenger/ Office Assistant" },
	{ name: "Watchman/ Guard", value: "Watchman/ Guard" }
]

const rateTypeOptions = [
	{ name: "Indoor", value: "indoor" },
	{ name: "Outdoor", value: "outdoor" },
	{ name: "Overseas", value: "overseas" }
]

const ratePresets = [
	{
		type: "Admin",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Managerial",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Clerical",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Sales",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Others",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Salesman (Carry Jewellery)",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Worker/ Goldsmith /Stonepicker",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Private Car Driver",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Amah/ Cleaning Worker",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Messenger/ Office Assistant",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	},
	{
		type: "Watchman/ Guard",
		rate: {
			indoor: 0,
			outdoor: 0,
			overseas: 0
		}
	}
]

const defaultValue = [
	{
		occupation: null,
		numberOfUnnamed: 0,
		rateType: null,
		rate: 0,
		annualPayroll: 0,
		jobDuties: null,
		isNamed: false,
		employeeId:
			Date.now() + ":" + Math.floor(Math.random() * 1000000000000000000)
	}
]

export default {
	props: {
		productId: {
			validator(value) {
				return typeof value === "object"
			}
		},
		caseId: String,
		proposalId: String,
		offerId: String
	},

	components: {
		JBaseSelect,
		JBaseInputText,
		JBaseInputNumber,
		JBaseToggle,
		JButton,
		CrmIcon,
		OccupationInput
	},

	data() {
		return {
			headerOfUnnamed: [
				"occupation",
				"numberOfUnnamed",
				"rateType",
				"rate",
				"annualPayroll",
				"jobDuties",
				"remove"
			],
			headerOfNamed: [
				"occupation",
				"employeeName",
				"rateType",
				"rate",
				"annualPayroll",
				"jobDuties",
				"remove"
			],
			newRowUnnamed: {
				occupation: null,
				numberOfUnnamed: 0,
				rateType: null,
				rate: 0,
				annualPayroll: 0,
				jobDuties: null,
				isNamed: false
			},
			newRowNamed: {
				occupation: null,
				employeeName: null,
				rateType: null,
				rate: 0,
				annualPayroll: 0,
				jobDuties: null,
				isNamed: true
			},
			values: null,
			pricing: null,
			productName: ""
		}
	},

	methods: {
		t(key) {
			const locale = {
				"en-US": {
					gross_amount: "Gross Amount",
					total_amount: "Total Amount",
					occupation: "Occupation",
					employeeName: "Name",
					numberOfUnnamed: "No. of Unnamed",
					isOverseas: "Overseas Rate",
					isIndoor: "Indoor Rate",
					rateType: "Rate Type",
					rate: "Rate(%)",
					annualPayroll: "Annual Payroll",
					jobDuties: "Job Duties",
					add_unnamed: "Add Unnamed",
					add_named: "Add Named",
					remove: "Remove",
					save_values: "Save Values",
					named: "Named Employees",
					unnamed: "Unnamed Employees",
					values_saved: "Values Saved"
				},
				"zh-HK": {}
			}
			return locale[this.$store.state.settings.locale][key]
		},

		decideComponent(key) {
			if (key === "occupation") return "OccupationInput"
			if (key === "rateType") return "JBaseSelect"
			if (key === "employeeName" || key === "jobDuties") return "JBaseInputText"
			if (
				key === "numberOfUnnamed" ||
				key === "rate" ||
				key === "annualPayroll"
			)
				return "JBaseInputNumber"
			else return null
		},

		decideProps(key) {
			return key === "occupation"
				? { options: occupations }
				: key === "rateType"
				? { options: rateTypeOptions }
				: null
		},

		addUnnamedRow() {
			// deepclone
			this.values.push(
				JSON.parse(
					JSON.stringify({
						...this.newRowUnnamed,
						employeeId:
							Date.now() + ":" + Math.floor(Math.random() * 1000000000000000000)
					})
				)
			)
		},

		addNamedRow() {
			// deepclone
			this.values.push(
				JSON.parse(
					JSON.stringify({
						...this.newRowNamed,
						employeeId:
							Date.now() + ":" + Math.floor(Math.random() * 1000000000000000000)
					})
				)
			)
		},

		removeRowFromValues(index) {
			this.values.splice(index, 1)
		},

		massageValuesFromAPI(values) {
			return values
				?.find(item => item.key === "insureds")
				?.value?.arrayValue?.map(item => {
					return item?.objectValue?.reduce((obj, item) => {
						let objKey = item?.key
						let objValue =
							item?.value?.stringValue !== null
								? item?.value?.stringValue
								: item?.value?.numberValue !== null && item?.key === "rate"
								? parseFloat((item?.value?.numberValue * 100).toFixed(6))
								: item?.value?.numberValue !== null
								? item?.value?.numberValue
								: item?.value?.booleanValue
								? item?.value?.booleanValue
								: null
						obj[objKey] = objValue
						return obj
					}, {})
				})
		},

		massageValuesForAPI(values) {
			return [
				{
					key: "insureds",
					value: {
						arrayValue: values?.map(obj => {
							return {
								objectValue: Object.keys(obj).map(key => {
									return {
										key,
										value:
											key === "rate"
												? { numberValue: parseFloat(obj[key]) / 100 }
												: typeof obj[key] === "string"
												? { stringValue: obj[key] }
												: typeof obj[key] === "number"
												? { numberValue: obj[key] }
												: typeof obj[key] === "boolean"
												? { booleanValue: obj[key] }
												: null
									}
								})
							}
						})
					}
				}
			]
		},

		async fetchValues() {
			const query = gql`
				fragment ObjectValue on scalarValue {
					objectValue {
						key
						value {
							stringValue
							numberValue
							booleanValue
						}
					}
				}

				query checkPolicyValues(
					$caseWhere1: caseWhere
					$offerWhere1: offerWhere
					$proposalWhere1: proposalWhere
				) {
					cases(where: $caseWhere1) {
						list {
							id
							proposals(where: $proposalWhere1) {
								basket(where: $offerWhere1) {
									id
									values {
										key
										value {
											arrayValue {
												...ObjectValue
											}
										}
									}
								}
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: {
					caseWhere1: { id: this.caseId },
					offerWhere1: { id: this.offerId },
					proposalWhere1: { id: this.proposalId }
				}
			})

			const result =
				res?.data?.cases?.list?.[0]?.proposals?.[0]?.basket?.[0]?.values

			// if offer has no values, we apply default values
			if (!result) {
				this.values = JSON.parse(JSON.stringify(defaultValue))
				return
			}

			this.values = this.massageValuesFromAPI(result)
		},

		async saveValues() {
			const query = gql`
				mutation updateOfferOfProposal(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$updateOfferInput: updateOfferInput!
				) {
					updateOfferOfProposal(
						caseId: $caseId
						offerId: $offerId
						proposalId: $proposalId
						updateOfferInput: $updateOfferInput
					) {
						errors
						errors_2 {
							code
							message
						}
						status
					}
				}
			`
			const variables = {
				caseId: this.caseId,
				proposalId: this.proposalId,
				offerId: this.offerId,
				updateOfferInput: {
					values: this.massageValuesForAPI(this.values)
				}
			}

			const res = await api({
				query,
				variables
			})

			if (!res?.data?.updateOfferOfProposal?.errors)
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.t("values_saved")
					}
				})

			this.$emit("premium:updated")
		},

		async fetchPrice() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			const query = gql`
				query getPrice($where: productWhereInput, $values: [keyValueInput]) {
					products: products_2(where: $where, values: $values) {
						list {
							name
							productId {
								plan
							}
							pricing(values: $values) {
								appliedTaxes {
									name
									code
									ratio
									formattedFlat
								}
								originalPrice
								formattedOriginalPrice
								amount
								formattedPrice
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: {
					where: {
						productId: {
							plan: this.plan
						}
					},
					values: this.massageValuesForAPI(this.values)
				}
			})

			this.productName = res?.data?.products?.list?.[0]?.name
			this.pricing = res?.data?.products?.list?.[0]?.pricing
		},

		debouncedFetchPrice: debounce(function() {
			this.fetchPrice()
		}, 500),

		handleInput({ index, key, $event }) {
			// get rate from rate present when changing rateType
			if (key === "rateType") {
				this.values[index].rate = ratePresets?.find(
					item => item.type === this.values[index].occupation
				)?.rate?.[$event]
			}
			// get rate from rate present when changing occupation
			if (key === "occupation") {
				this.values[index].rate = ratePresets?.find(
					item => item.type === $event
				)?.rate?.[this.values[index]?.rateType]
			}
			this.values[index][key] = $event
			this.debouncedFetchPrice()
		},

		getValue(item) {
			if (!item) return ""
			const ratio = item.ratio ? item.ratio * 100 : null
			const flat = item.formattedFlat ? item.formattedFlat : "0"
			return {
				flat,
				summary: ratio
					? `(${ratio ? ratio.toFixed(6) : "0"}% of ${
							item.formattedOriginalPrice
					  })`
					: ""
			}
		}
	},

	computed: {
		computedFormattedPricing() {
			return [
				{ name: "gross_amount", value: this.pricing?.formattedOriginalPrice },
				{
					name: "total_amount",
					value: this.pricing?.formattedPrice
				}
			]
		},
		computedTaxes() {
			return this.pricing?.appliedTaxes?.map(item => {
				return {
					name: item.name ? item.name : item.code,
					value: this.getValue(item).flat
				}
			})
		},
		plan() {
			return this.productId?.plan
		}
	},

	async created() {
		await this.fetchValues()
		await this.fetchPrice()
	},

	watch: {
		// When productId updates, refetch data
		// This is need because we use same component for different productId
		// And thus we have to refetch as AegPricing doesn't remount the component
		productId: {
			handler() {
				this.fetchPrice()
			}
		},
		// when offerId changes,
		// reset productType to default
		// and refetch values
		offerId: async function() {
			await this.fetchValues()
		},
		values: {
			handler() {
				this.debouncedFetchPrice()
			},
			deep: true
		}
	}
}
</script>
